import { create } from "./create";

export default create();
